export { default, default as useGetPracticeInfo } from "./useGetPracticeInfo";
